export default __webpack_public_path__ + "images/multisignature_f16506.svg";